import React, { useEffect, useState } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var TimedPopup = props => {
  var {
    children,
    delay
  } = props;
  var [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setIsOpen(false);
    setTimeout(() => setIsOpen(true), delay ? delay * 1000 : 2000);
  }, [delay]);
  var childrenWithProps = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        isOpen,
        setIsOpen
      });
    }

    return child;
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: childrenWithProps
  });
};
//# sourceMappingURL=timedpopup.js.map